import React from "react";

import {
  EmptyStateContainer,
  EmptyStateDescription,
  EmptyStateDetails,
  EmptyStateHeading,
} from "./styles";
import { EMPTY_STATE_TEMPLATE } from "./templates";

const EmptyState = ({ template = "" }) => {
  return (
    <EmptyStateContainer>
      <EmptyStateDetails>
        <img
          src={EMPTY_STATE_TEMPLATE[template].imageUrl}
          alt="Getting started"
          width={310}
        />
        <EmptyStateHeading>
          {EMPTY_STATE_TEMPLATE[template].title}
        </EmptyStateHeading>
        <EmptyStateDescription>
          {EMPTY_STATE_TEMPLATE[template].description}
        </EmptyStateDescription>
      </EmptyStateDetails>
    </EmptyStateContainer>
  );
};

export default EmptyState;
